// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"499":"2da48d5c","556":"b15e50e7","707":"829a6321"}[chunkId] + ".chunk.js";
};